import { DefaultTheme } from "styled-components";
import {
  BDA_THEME_AGENT_NAMES,
  GVT_THEME_AGENT_NAMES,
  NEW_GATE1_THEME_AGENT_NAMES,
  NEW_TIX_THEME_AGENT_NAMES,
  VLIEGTICKETS_THEME_AGENT_NAMES,
  WTC_THEME_AGENT_NAMES,
} from "../constants/agentNamesPerTheme";
import { newTixTheme } from "../themes/newTixTheme";
import { vliegticketsTheme } from "../themes/vliegticketsTheme";
import { bdaTheme } from "../themes/bdaTheme";
import { wtcTheme } from "../themes/wtcTheme";
import { gvtTheme } from "../themes/gvtTheme";
import { newGate1Theme } from "../themes/newGate1Theme";
import { oldGate1Theme } from "../themes/oldGate1Theme";
import { oldTixTheme } from "../themes/oldTixTheme";
import { ConfigTemplate } from "../enums/ConfigTemplate";

export const getThemeForAgentName = (
  agentName: string,
  template: ConfigTemplate
): DefaultTheme => {
  if (NEW_TIX_THEME_AGENT_NAMES.includes(agentName.toLowerCase())) {
    return newTixTheme;
  } else if (VLIEGTICKETS_THEME_AGENT_NAMES.includes(agentName.toLowerCase())) {
    return vliegticketsTheme;
  } else if (WTC_THEME_AGENT_NAMES.includes(agentName.toLowerCase())) {
    return wtcTheme;
  } else if (BDA_THEME_AGENT_NAMES.includes(agentName.toLowerCase())) {
    return bdaTheme;
  } else if (GVT_THEME_AGENT_NAMES.includes(agentName.toLowerCase())) {
    return gvtTheme;
  } else if (NEW_GATE1_THEME_AGENT_NAMES.includes(agentName.toLowerCase())) {
    return newGate1Theme;
  } else if (template === ConfigTemplate.Gate1) {
    return oldGate1Theme;
  } else {
    return oldTixTheme;
  }
};
